import { DefaultState } from '@src/redux/types'

import { CHAT_GROUP_BY_COMPONENT, CHAT_GROUP_BY_ID, MESSAGES_GROUP, MESSAGES_GROUP_ALL } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [CHAT_GROUP_BY_COMPONENT]: DefaultState<`${typeof API.CHAT_GROUP_BY_COMPONENT}`, 'get'>
  [MESSAGES_GROUP]: DefaultState<`${typeof API.MESSAGES_GROUP}`, 'get'>
  [CHAT_GROUP_BY_ID]: DefaultState<`${typeof API.CHAT_GROUP}{id}`, 'get'>
  [MESSAGES_GROUP_ALL]: DefaultState<`${typeof API.MESSAGES_GROUP_ALL}`, 'get'>
} = () => ({
  [CHAT_GROUP_BY_COMPONENT]: defaultState(),
  [MESSAGES_GROUP]: defaultState(),
  [CHAT_GROUP_BY_ID]: defaultState(),
  [MESSAGES_GROUP_ALL]: defaultState(),
})
